import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import * as Auth from '@morningtrain/react-auth'
import {
  ExecuteOperationForModelOnPipe,
  ExecuteOperationOnPipe,
  SubmitFormOnPipe,
  useOperation
} from '@morningtrain/react-resources'
import { SquareButton } from 'ui/buttons'
import * as Icons from 'ui/icons'
import { NestedAsyncPipeline } from '@morningtrain/react-pipelines'
import ConfirmOnClickPipeline from 'support/pipelines/ConfirmOnClickPipeline'

function Approve (props) {
  const parentOperation = useOperation()

  const resource = parentOperation.resource
  const namespace = props.namespace || resource.namespace || 'api'
  const resourceName = resource.slug
  const operationName = props.operationName || 'approve'

  return (
    <Auth.CanUseModel permission={[namespace, resourceName, operationName].join('.')}>
      <ConfirmOnClickPipeline trigger={props.trigger
        ? props.trigger
        : (
          <SquareButton color='btn-green'>
            <Icons.Checkmark style={{ width: '14px' }} />
          </SquareButton>
          )}
      >
        <SubmitFormOnPipe/>
        <ExecuteOperationForModelOnPipe namespace={namespace} resourceName={resourceName}
                                        operationName={operationName}/>
        <NestedAsyncPipeline>
          <ExecuteOperationOnPipe namespace={namespace} resourceName={resourceName} operationName={props.indexOperationName || 'index'} />
          {props.children}
        </NestedAsyncPipeline>
      </ConfirmOnClickPipeline>
    </Auth.CanUseModel>
  )
}

Approve.propTypes = {
  namespace: PropTypes.string,
  resourceName: PropTypes.string,
  operationName: PropTypes.string,
  indexOperationName: PropTypes.string
}

export default observer(Approve)
